import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { host } from "../../config/Config";
import "./style.css";

export const MyEducations = () => {
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchApplications();
    }, []);

    const fetchApplications = async () => {
        try {
            const token =
                localStorage.getItem("jwt-vlada") ||
                localStorage.getItem("zajednica-token");
            if (!token) {
                navigate("/login");
                return;
            }

            // Decode JWT to get username (phone)
            const payload = JSON.parse(atob(token.split(".")[1]));
            const username = payload.sub;

            // Find user by username (phone) to get userId
            const userResponse = await fetch(
                `${host}/api/v1/users/by-username/${username}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!userResponse.ok) {
                navigate("/login");
                return;
            }

            const userData = await userResponse.json();
            const userId = userData.id;

            const response = await fetch(
                `${host}/api/v1/education-applications/user/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setApplications(data);
            } else if (response.status === 401) {
                navigate("/login");
            } else {
                setError("Došlo je do greške pri učitavanju prijava.");
            }
        } catch (err) {
            console.error("Error fetching applications:", err);
            setError("Došlo je do greške pri učitavanju prijava.");
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        const badges = {
            PENDING: { text: "Na čekanju", className: "status-pending" },
            APPROVED: { text: "Odobreno", className: "status-approved" },
            REJECTED: { text: "Odbijeno", className: "status-rejected" },
        };
        return badges[status] || badges.PENDING;
    };

    const getEducationName = (type) => {
        const names = {
            "hands-on": "Hands-On Edukacija",
            "look-and-learn": "Look & Learn Edukacija",
            "one-on-one": "One-on-One Edukacija",
            fade: "Fade Workshop",
            formation: "Formation Workshop",
            "creative-formation": "Creative Formation Workshop",
            fundamental: "Fundamental Workshop",
            "nine-week": "9 Nedeljna Edukacija",
            "twelve-week": "12 Nedeljna Edukacija",
            online: "Online Edukacija",
        };
        return names[type] || type;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("sr-RS");
    };

    if (loading) {
        return (
            <div className='barber-zajednica-admin-page'>
                <div className='barber-zajednica-admin-background'></div>
                <h1>Učitavanje...</h1>
            </div>
        );
    }

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <div style={{ marginBottom: "40px" }}>
                <h1 style={{ marginBottom: "10px", fontSize: "32px" }}>
                    Moje Edukacije
                </h1>
            </div>

            {error && (
                <div
                    style={{
                        color: "red",
                        padding: "15px",
                        marginBottom: "20px",
                        backgroundColor: "#ffe6e6",
                        borderRadius: "8px",
                    }}
                >
                    {error}
                </div>
            )}

            {applications.length === 0 ? (
                <div
                    style={{
                        padding: "60px 40px",
                        textAlign: "center",
                        backgroundColor: "#1e1e1e",
                        borderRadius: "16px",
                        border: "2px solid #be9455",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                        width: "80%",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 10,
                    }}
                >
                    <h2
                        style={{
                            fontSize: "26px",
                            color: "#be9455",
                            marginBottom: "15px",
                            fontWeight: "bold",
                        }}
                    >
                        Nema prijavljenih edukacija
                    </h2>
                    <p
                        style={{
                            fontSize: "18px",
                            color: "#ccc",
                            marginBottom: "30px",
                            lineHeight: "1.6",
                        }}
                    >
                        Trenutno nemate aktivnih prijava. Pogledajte našu ponudu
                        i prijavite se za edukaciju.
                    </p>
                    <button
                        onClick={() => navigate("/educations")}
                        style={{
                            backgroundColor: "#be9455",
                            color: "#121212",
                            border: "none",
                            padding: "16px 40px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginTop: "40px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            position: "relative",
                            zIndex: 20,
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#d4a870";
                            e.target.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#be9455";
                            e.target.style.transform = "translateY(0)";
                        }}
                    >
                        Pogledaj edukacije
                    </button>
                </div>
            ) : (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        width: "85%",
                        margin: "0 auto",
                    }}
                >
                    {applications.map((app) => {
                        const statusBadge = getStatusBadge(app.status);
                        return (
                            <div
                                key={app.id}
                                style={{
                                    backgroundColor: "#1e1e1e",
                                    borderRadius: "16px",
                                    padding: "40px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                    border: "2px solid #333",
                                }}
                            >
                                <div
                                    style={{
                                        marginBottom: "30px",
                                        borderBottom: "1px solid #333",
                                        paddingBottom: "20px",
                                        textAlign: "center",
                                    }}
                                >
                                    <h3
                                        style={{
                                            fontSize: "28px",
                                            margin: "0 0 15px 0",
                                            color: "#be9455",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {getEducationName(app.educationType)}
                                    </h3>
                                    <span
                                        className={statusBadge.className}
                                        style={{
                                            display: "inline-block",
                                            padding: "10px 20px",
                                            borderRadius: "20px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {statusBadge.text}
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: "20px",
                                        color: "#ccc",
                                        fontSize: "18px",
                                    }}
                                >
                                    {app.slotDate && (
                                        <div
                                            style={{
                                                padding: "15px",
                                                backgroundColor: "#121212",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    color: "#888",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                📅 DATUM
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "20px",
                                                    color: "#be9455",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {formatDate(app.slotDate)}
                                            </div>
                                        </div>
                                    )}
                                    {app.startTime && app.endTime && (
                                        <div
                                            style={{
                                                padding: "15px",
                                                backgroundColor: "#121212",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    color: "#888",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                🕐 VREME
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "20px",
                                                    color: "#be9455",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {app.startTime.substring(0, 5)}{" "}
                                                - {app.endTime.substring(0, 5)}
                                            </div>
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            padding: "15px",
                                            backgroundColor: "#121212",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: "16px",
                                                color: "#888",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            💰 CENA
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "20px",
                                                color: "#be9455",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            €{app.totalPrice}
                                        </div>
                                    </div>
                                    {app.createdAt && (
                                        <div
                                            style={{
                                                padding: "15px",
                                                backgroundColor: "#121212",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    color: "#888",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                📝 PRIJAVLJENO
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "20px",
                                                    color: "#be9455",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {formatDate(app.createdAt)}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Back button at the bottom */}
            <div
                style={{
                    padding: "60px 20px 40px 20px",
                    textAlign: "center",
                    position: "relative",
                    zIndex: 10,
                }}
            >
                <button
                    onClick={() => navigate("/profile")}
                    style={{
                        backgroundColor: "#be9455",
                        color: "#121212",
                        border: "none",
                        padding: "15px 40px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 10,
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#a07d3f";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#be9455";
                    }}
                >
                    Nazad na Profil
                </button>
            </div>
        </div>
    );
};
